import { buildEventName } from "../buildEventName";
import { buildEventStartDate } from "../buildEventStartDate";
export function parseEvent(options) {
    const { event, hasScoreboard, staticS3Host, logos, formatEventDate, isSwooshTeamLogosEnabledForPrePacks, swooshBaseUrl, dict, } = options;
    return {
        eventId: event.id,
        nameStructure: buildEventName({
            event,
            logos,
            staticS3Host,
            hasScoreboard,
            isSwooshTeamLogosEnabledForPrePacks,
            swooshBaseUrl,
            dict,
        }),
        eventNameIdentifier: event.eventName,
        startDate: options.hasScoreboard
            ? undefined
            : buildEventStartDate(event.startDate, formatEventDate),
        tags: event.tags,
    };
}
//# sourceMappingURL=parseEvent.js.map